exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-image__container {\n  position: relative;\n  width: 100%;\n}\n.v-image__img {\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 100%;\n}\n", ""]);

// exports
